'use strict';

angular.module('atex.dam').factory('QueueSelectModal', [ '$rootScope', '$q', '$modal', '$sce',
  '$injector', '$timeout', 'DamNotificationService', 'DamSearchService', 'ContentService',
function($rootScope, $q, $modal, $sce,
         $injector, $timeout, DamNotificationService, DamSearchService, ContentService ) {
  var ADMUtils;
  var ADMService;
  var PrintService;

  return {
    create : function(props) {
      var modalScope = $rootScope.$new(true);
      _.extend(modalScope, props);

      var modal;
      var deferred = $q.defer();

      if ( !ADMUtils ) {
        ADMUtils = $injector.get("ADMUtils");
      }

      var header = ADMUtils.translate('_PLEASE_SELECT_');
      var method = ADMUtils.translate(modalScope.copy ? '_COPY_TO_QUEUE_' : '_SEND_TO_QUEUE_' );


      modalScope.confirmBody = $sce.trustAsHtml( header + ' ' + method );


      ADMUtils.ModelUtils.initialiseModel( 'queue_select',
        '', '', modalScope );
      ADMUtils.ModelUtils.initAttribute( modalScope.queryModel, 'profile_atex_desk_ss' );


      var destroyModal = function() {
        if ( modal )  {
          modal.then(function(modalEl) {
            modalEl.on('hidden.bs.modal', function() {
              modalScope.$destroy();
            });

            modalEl.modal('hide');
          });
        }
      };

      var getContents = function(contentIds, entries) {
        var promises = contentIds.map(function (contentId) {
          return ContentService.getContent({id :contentId}).then(function(content) {
            entries.push(content);
          });
        });

        return $q.all(promises);
      };

      var sendToQueue = function( drag, ids, queue ) {
        var contentOptions = {
          contentId: drag.contentId,
          layoutOptions: {},
          subType: 'sendToQueue',
          contentData: {
            copy: !!modalScope.copy,
            spike: !!modalScope.spike,
            ids: ids,
            dragUrl: drag.url,
            queue: queue
          }
        };

        if ( !PrintService ) {
          PrintService = $injector.get("PrintService");
        }

        PrintService.content(contentOptions).then(function (data) {
          if ( !data.errorReported ) {
            DamNotificationService.addNotification(atex.dam.Notification({
              type: 'success',
              message: ADMUtils.translate('__OPERATION_COMPLETED_SUCCESSFULLY__')
            }), false);
          }

          $timeout( function() {
            DamSearchService.refresh();
          }, 2000 );

          deferred.resolve({
            ok: true,
            queue: queue
          });
        }).catch(function (error) {
          var message = ADMUtils.translate('__GENERIC_ERROR_MSG__');
          DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);

          deferred.resolve({
            ok: true,
            queue: queue
          });
        });
      };

      modalScope.doCancel = function() {
        destroyModal();
        deferred.resolve({ ok: false });
      };

      modalScope.doOk = function() {
        destroyModal();

        if ( !ADMUtils ) {
          ADMUtils = $injector.get("ADMUtils");
        }

        var queue;

        if ( !modalScope.spike ) {
          ADMUtils.ModelUtils.saveModel(modalScope);
          queue = ADMUtils.ModelUtils.getAttribute(modalScope.queryModel.set, 'queue_atex_desk_s');
        }

        if ( !modalScope.spike && _.isEmpty( queue ) ) {
          DamNotificationService.addNotification(atex.dam.Notification({
            type: 'error',
            message: ADMUtils.translate('__NO_QUEUE_SELECTED__')
          }), false);
        } else {
          var hasDoc = false;
          if ( modalScope.copy && !_.isEmpty( modalScope.selected ) ) {
            modalScope.selected.forEach(function (entry) {
              var contentData = entry._data.aspects.contentData.data;
              if (typeof contentData.objectType !== 'undefined') {
                var objectType = contentData.objectType;

                if (objectType === 'page' ) {
                  hasDoc = true;
                }
              }
            });
          }

          var drag = ADMUtils.DnDUtils.createDragUrl( modalScope.selected );
          var ids = atex.dam.AngularUtils.getIdsArray( modalScope.selected );

          if ( drag ) {
            if ( modalScope.copy && !hasDoc ) {
              modalScope.copy = false;
              if ( !ADMService ) {
                ADMService = $injector.get("ADMService");
              }
              ADMService.duplicate(ids).then(function (contents, idx) {
                  var entries = [];
                  getContents( contents, entries ).then(function() {
                    drag = ADMUtils.DnDUtils.createDragUrl( entries );
                    ids = atex.dam.AngularUtils.getIdsArray( entries );

                    sendToQueue(drag, ids, queue);
                  });
                 }).then(null, function(error) {
                  var message = ADMUtils.translate('__GENERIC_ERROR_MSG__');
                  DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
                  deferred.resolve({
                    ok: false,
                    queue: queue
                  });
                });
            } else {
              sendToQueue(drag, ids, queue);
            }
          }
        }
      };

      if ( !modalScope.spike ) {
        modal = $modal({
          show: true,
          scope: modalScope,

          template: 'views/queue-select-modal.html',
          modalClass: 'confirm-modal ng-cloak',
          backdrop: 'static',
          keyboard: false
        });
      } else {
        modalScope.doOk();
      }


      return deferred.promise;
    }
  };
} ]);
